<template>
    <modal 
        :show="show" 
        :title="modalTitle" 
        :saveButton="{visible: false}"
        :cancelButton="{title:'Fechar'}"
        size="medium" 
        :needHeader="false" 
        :relativeBackdrop="true" 
        :contentCentered="contentCentered" 
        class="modal-info" 
        @close="closeModal" 
        @save=""
    >
        <div class="form-group" :class="classContent" v-html="infoHtml">

        </div>
    </modal>
</template>

<script>
import Modal from './Modal';
export default {
    name: 'modal-info',
    components: { Modal },
    props: {
        title: {
            type: String,
        },
        classContent: {
            type: String,
            default: 'mx-sm-3'
        },
        contentCentered: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            show: false,
            modalTitle: null,
            modalContentCentered: true,
            infoHtml: '',
        }
    },
    mounted() {
        this.modalTitle = this.title;
        this.modalContentCentered = this.contentCentered;
    },
    computed: {
    },
    methods: {
        open: function(params) {
            this.show=true;
            this.infoHtml = params.html;
            if(params.title){
                this.modalTitle = params.title;
            }
            if(params.contentCentered != undefined){
                this.modalContentCentered = params.contentCentered;
            }
        },
        closeModal: function() {
            this.show=false;
        },
    }
}
</script>